import { useEffect } from "react";

// Empêche la mise en veille de l'écran/CPU tant que la page (POS/KDS/Serveur/Manager)
// reste au premier plan. Se ré-acquiert automatiquement au retour de veille.
export function useWakeLock() {
  useEffect(() => {
    if (!("wakeLock" in navigator)) return;
    let lock = null;
    let cancelled = false;
    const acquire = async () => {
      try { lock = await navigator.wakeLock.request("screen"); } catch (e) {}
    };
    const onVisible = () => { if (document.visibilityState === "visible" && !cancelled) acquire(); };
    acquire();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisible);
      try { lock && lock.release(); } catch (e) {}
      lock = null;
    };
  }, []);
}
